export default __webpack_public_path__ + "static/media/Naga_21-22.912d2ee0.png";